import {getPromotionTypeName, PromotionType} from "../helpers/PromotionType";
import {AmplitudeOfferPromotionCreativeSlot, IAmplitudeOfferPromotionTrackingParamsWithItemId} from "./get_amplitude_offer_promotion_event_properties";

export interface IAmplitudeOfferPagePromotionSource {
    id: number;
    name: string;
    description: string | null;
    type?: number;
}

interface IGetAmplitudeOfferPagePromotionTrackingContextParams {
    promotion: IAmplitudeOfferPagePromotionSource;
    offerId: number;
    propertyId?: number | null;
    itemListId?: string;
    creativeSlot: AmplitudeOfferPromotionCreativeSlot;
}

export const getAmplitudeOfferPagePromotionTrackingContext = (
    params: IGetAmplitudeOfferPagePromotionTrackingContextParams
): IAmplitudeOfferPromotionTrackingParamsWithItemId => {
    const promotionType =
        params.promotion.type !== undefined && params.promotion.type !== null ? (params.promotion.type as PromotionType) : PromotionType.PROMOTION;
    const headline = params.promotion.name?.trim() || getPromotionTypeName(promotionType);

    return {
        creativeName: headline,
        creativeSlot: params.creativeSlot,
        promotionId: params.promotion.id,
        promotionName: params.promotion.name?.trim() || headline,
        promotionContent: params.promotion.description?.trim() || null,
        location: params.propertyId != null ? "property_page" : "investment_page",
        itemListId: params.itemListId,
        itemId: params.offerId,
        propertyId: params.propertyId ?? undefined
    };
};
import {getPromotionTypeName, PromotionType} from "../helpers/PromotionType";
import {AmplitudeOfferPromotionCreativeSlot, IAmplitudeOfferPromotionTrackingParamsWithItemId} from "./get_amplitude_offer_promotion_event_properties";

export interface IAmplitudeOfferPagePromotionSource {
    id: number;
    name: string;
    description: string | null;
    type?: number;
}

interface IGetAmplitudeOfferPagePromotionTrackingContextParams {
    promotion: IAmplitudeOfferPagePromotionSource;
    offerId: number;
    propertyId?: number | null;
    itemListId?: string;
    creativeSlot: AmplitudeOfferPromotionCreativeSlot;
}

export const getAmplitudeOfferPagePromotionTrackingContext = (
    params: IGetAmplitudeOfferPagePromotionTrackingContextParams
): IAmplitudeOfferPromotionTrackingParamsWithItemId => {
    const promotionType =
        params.promotion.type !== undefined && params.promotion.type !== null ? (params.promotion.type as PromotionType) : PromotionType.PROMOTION;
    const headline = params.promotion.name?.trim() || getPromotionTypeName(promotionType);

    return {
        creativeName: headline,
        creativeSlot: params.creativeSlot,
        promotionId: params.promotion.id,
        promotionName: params.promotion.name?.trim() || headline,
        promotionContent: params.promotion.description?.trim() || null,
        location: params.propertyId != null ? "property_page" : "investment_page",
        itemListId: params.itemListId,
        itemId: params.offerId,
        propertyId: params.propertyId ?? undefined
    };
};
